export default function getDistance(lat1, lng1, lat2, lng2) { // miles optional

  function deg2rad(deg){
    return deg * (Math.PI/180);
  }

  function square(x) {
    return Math.pow(x, 2);
  }

  let r = 6371; // radius of the earth in km
  lat1 = deg2rad(lat1);
  lat2 = deg2rad(lat2);
  let lat_dif = lat2 - lat1;
  let lng_dif = deg2rad(lng2-lng1);
  let a = square(Math.sin(lat_dif/2))+Math.cos(lat1)*Math.cos(lat2)*square(Math.sin(lng_dif/2));
  let d = 2*r*Math.asin(Math.sqrt(a));
  let result = d * 0.621371;
  return Math.round(result * 10) / 10
}